import { types } from "../types/types";

const initialState = {
  rows: [],
  loading: false,
  saving: false,
  fields: [],
  openTextEnabled: false,
  titleEnabled: false,
  briefEnabled: false,
  selected: null,
  labels: {}
};

export const searchKeyTermReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SEARCH_KEY_TERM_SET_LOADING:
      return { ...state, loading: action.payload };
    case types.SEARCH_KEY_TERM_SET_ROWS:
      return {
        ...state,
        loading: false,
        rows: action.payload.rows || [],
        titleEnabled: Boolean(action.payload.titleEnabled)
      };
    case types.SEARCH_KEY_TERM_SET_FIELDS:
      return {
        ...state,
        fields: action.payload.rows,
        openTextEnabled: action.payload.openTextEnabled,
        titleEnabled: action.payload.titleEnabled,
        briefEnabled: action.payload.briefEnabled
      };
    case types.SEARCH_KEY_TERM_SET_SAVING:
      return { ...state, saving: action.payload };
    case types.SEARCH_KEY_TERM_SET_SELECTED:
      return {
        ...state,
        selected: action.payload?.row || null,
        labels: action.payload?.labels || {}
      };
    default:
      return state;
  }
};
